export function getQualityEntryAttachmentMin(
  attachmentsEnabled?: boolean,
  attachmentsRequired?: boolean,
  attachmentMinOverride?: number
) {
  return attachmentsEnabled
    ? attachmentMinOverride || attachmentMinOverride === 0
      ? attachmentMinOverride
      : attachmentsRequired
        ? 1
        : undefined
    : undefined;
}
